import {
  getClients,
  getTransactionReport,
  getClientById,
} from "@/api/hc360-transactions.js";

const transactions = {
  namespaced: true,

  state: () => ({
    filters: {
      client_selected: null,
      bill_to: null,
      start_date: null,
      end_date: null,
      pg_num: 1,
      pg_size: 10,
    },
    getClientsData: null,
    getTransactionReportData: null,
    getClientByIdData: null,
    tab: "invoices",
    Loading: false,
  }),

  //   getters: {
  //     getState: (state) => {
  //       return state.stateName;
  //     },
  //   },

  actions: {
    getClients({ state, commit }, params) {
      if (state.getClientsData) return;
      return new Promise((resolve, reject) => {
        getClients()
          .then((api_data) => {
            state.getClientsData = api_data;
            resolve(api_data);
          })
          .catch((err) => {
            reject(err);
            console.log("getClients store err", err);
          });
      });
    },

    getClientById({ state, commit }, params) {
      return new Promise((resolve, reject) => {
        getClientById(params)
          .then((api_data) => {
            state.getClientByIdData = api_data;
            resolve(api_data);
          })
          .catch((err) => {
            reject(err);
            console.log("getClientById store err", err);
          });
      });
    },

    getTransactionReport({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        getTransactionReport(payload)
          .then((api_data) => {
            state.getTransactionReportData = api_data;
            resolve(api_data);
          })
          .catch((err) => {
            reject(err);
            console.log("getTransactionReport store err", err);
          });
      });
    },
  },

  mutations: {
    TOGGLE_LOADING: (state) => {
      state.Loading = !state.Loading;
    },
    TOGGLE_TAB: (state, data) => {
      console.log(data);
      state.tab = data;
    },
    SET_FILTERS: (state, { client, sDate, eDate, bill_to }) => {
      state.filters = {
        client_selected: client,
        bill_to: bill_to,
        start_date: sDate,
        end_date: eDate,
        pg_num: state.getTransactionReportData.page_number,
        pg_size: state.getTransactionReportData.page_size,
      };
    },
    SET_DATA: (state, { getTransactionReportData, getClientByIdData }) => {
      state.getTransactionReportData = getTransactionReportData;
      state.getClientByIdData = getClientByIdData;
    },
  },
};

export default transactions;
